import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'default_web_app';

const supportEmail = {
	demo: 'info@demo-app.smoothr.de',
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyCbcKRCUPN_83_EGNoL3bADqlCQieRfD5k',
		authDomain: 'dev-demo-app-5892c.firebaseapp.com',
		projectId: 'dev-demo-app-5892c',
		storageBucket: 'dev-demo-app-5892c.firebasestorage.app',
		messagingSenderId: '31296248383',
		appId: '1:31296248383:web:e6c6ac437cb7c7527f768a',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyDAdrZ5vG1_A-5rChcnhh6UQjfhX1OI9QE',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	...apiEnvironment,
	countryList: ['de', 'at', 'lu', 'ch'],
	gaId: '',
	hasRecommendations: true,
	apiUrl: 'https://dev-demo-app.smoothr.de/',
	location: '',
	deactivateDelivery: false,
	enableCashPayment: false,
	allowNavigationToWorldline: false,
};
